/* ConfigAuditActionScreenComponent.js */

"use strict";
const EventEmitter = require("events");
const ParamsVeilComponent = require("./veils/ConfigAuditParams/ConfigAuditParamsComponent");
const ScheduleVeilComponent = require("../../../../lib/actions/veils/schedule/ScheduleVeilComponent");

class ConfigAuditActionScreenComponent extends EventEmitter {
    constructor(showDeviceSelection, modalUserFeedback, getPolicyLabels, logger) {
        super();
        this._logger = logger;
        this._modalUserFeedback = modalUserFeedback;
        this.data = {};
        this._getParamsView = (resolver) => new ParamsVeilComponent(this, showDeviceSelection, getPolicyLabels, resolver, logger);
        this._getScheduleView = () => new ScheduleVeilComponent(logger, true, "Audit - Schedule", { workType: "audit", firstTime: true });

        this.viewProm = {};
    }

    setParamsView() {
        this._modalUserFeedback
            .displayCustom(this._getParamsView(this.viewProm.resolve), {})
            .then((paramsData) => this.viewProm.resolve(this.updateData(paramsData)), this.viewProm.reject);
    }

    setScheduleView() {
        this._modalUserFeedback
            .displayCustom(this._getScheduleView(), {})
            .then((scheduleData) => this.viewProm.resolve(this.updateData(scheduleData)), this.viewProm.reject);
    }

    updateData(newData) {
        this.data = Object.assign({}, this.data, newData);
        return this.data;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    /**
     *
     * @return {Promise<Object|Error>}
     */
    showTheView() {
        this.viewProm.promise = new Promise((resolve, reject) => {
            this.viewProm.resolve = resolve;
            this.viewProm.reject = reject;
            this.setParamsView();
        })
            .then(this.updateData.bind(this))
            .catch((err) => Promise.reject(err));
        return this.viewProm.promise;
    }

    shutdown() {
        this._unregisterListeners();
        return Promise.all([])
            .then(() => {
                this.viewProm = null;
                this._modalUserFeedback = null;
                this.data = null;
            })
            .catch((error) => this._logger.warn({ error }, `${this.constructor.name}  shutdown Error`));
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = ConfigAuditActionScreenComponent;
